import {
  TYPE_INSTALLATION,
  TYPE_RECYCLING
} from '../components/SingleContainer/SingleContainer.jsx';

class SimpleParser {
  static parse(html, type) {
    if (html) {
      const parser = new DOMParser();

      try {
        const parsedHtml = parser.parseFromString(html, 'text/html');
        const heading = parsedHtml.getElementsByTagName('p')[0].textContent;
        const itemsHtml = parsedHtml.getElementsByTagName('ol')[0].children;

        const items = [];
        for (let i = 0; i < itemsHtml.length; i++) {
          items.push(itemsHtml[i].textContent);
        }
        return [heading, items];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`PSA R&I: Unable to parse HTML: ${html}`);
        // eslint-disable-next-line no-console
        console.error('PSA R&I: Returning default values');
        return SimpleParser.getDefaultValues(type);
      }
    } else {
      return SimpleParser.getDefaultValues(type);
    }
  }

  static getDefaultValues(type) {
    const items = [];

    if (type === TYPE_INSTALLATION) {
      items.push('Disconnect your old appliance');
      items.push('Connect up your new appliance');
      items.push('Test everything works OK');
    } else if (type === TYPE_RECYCLING) {
      items.push('Remove an old, disconnected appliance');
      items.push('Remove your new appliance\'s packaging');
      items.push('Take the lot to be recycled');
    }

    return [
      'On delivery, we’ll:',
      items
    ];
  }
}

export default SimpleParser;
